<template>
  <a
    class="logo-wrapper"
    href="https://www.makietainteraktywna.pl/"
    target="_blank"
  >
    <img
      class="logo"
      src="@/assets/logo-yslab.svg"
      alt="YSLAB logo"
      draggable="false"
    >
  </a>
</template>

<script>
export default {
  name: 'YslabLogo',
};
</script>

<style lang="scss" scoped>
.logo-wrapper {
  width: 75px;
  height: 36px;
  position: fixed;
  z-index: 1000;
  left: 0;
  bottom: 0;
  background-color: white;
  box-shadow: 0px 4px 21px 0px rgba(0, 0, 0, 0.1);
  border-top-right-radius: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
  .logo {
    width: 52px;
    height: 12px;
  }
}
</style>
